// components/CookieManager.jsx
import React, { useState, useEffect } from 'react';
import './CookieManager.css';
import cookie from "../assets/cookie.png";
import cookies from "../assets/cookies.png";
import inovact from "../assets/inovact.png";

const CookieManager = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showFloatingButton, setShowFloatingButton] = useState(false);
  const [cookieSettings, setCookieSettings] = useState({
    necessary: true,
    preferences: false
  });

  // Durée de conservation : 60 jours en millisecondes
  const COOKIE_DURATION_DAYS = 60;
  const COOKIE_EXPIRY_MS = COOKIE_DURATION_DAYS * 24 * 60 * 60 * 1000;

  // Vérifier le consentement au chargement
  useEffect(() => {
    const savedSettings = localStorage.getItem('cookie_settings');
    const consentGiven = localStorage.getItem('cookie_consent_given');
    const consentDate = localStorage.getItem('cookie_consent_date');

    // Vérifier si le consentement est encore valide (60 jours)
    let isConsentValid = false;
    if (consentDate) {
      const consentTime = new Date(consentDate).getTime();
      const currentTime = new Date().getTime();
      const daysPassed = (currentTime - consentTime) / (1000 * 3600 * 24);
      isConsentValid = daysPassed < COOKIE_DURATION_DAYS;
    }

    // Si pas de consentement OU consentement expiré, afficher la bannière
    if (!savedSettings || !consentGiven || !isConsentValid) {
      setShowBanner(true);
      setShowFloatingButton(false);
    } else {
      // Consentement valide, appliquer les paramètres
      const settings = JSON.parse(savedSettings);
      setCookieSettings(settings);
      setShowBanner(false);
      setShowFloatingButton(true);
    }
  }, []);

  // Sauvegarder le consentement avec date d'expiration
  const saveConsent = (settings) => {
    const now = new Date();
    const expiryDate = new Date(now.getTime() + COOKIE_EXPIRY_MS);

    localStorage.setItem('cookie_settings', JSON.stringify(settings));
    localStorage.setItem('cookie_consent_given', 'true');
    localStorage.setItem('cookie_consent_date', now.toISOString());
    localStorage.setItem('cookie_expiry_date', expiryDate.toISOString());

    console.log(`🍪 Consentement sauvegardé jusqu'au : ${expiryDate.toLocaleDateString()}`);
  };

  // Accepter tous les cookies
  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      preferences: true
    };

    setCookieSettings(allAccepted);
    saveConsent(allAccepted);
    setShowModal(false);
    setShowBanner(false);
    setShowFloatingButton(true);

    console.log('✅ Cookies acceptés pour 60 jours');
  };

  // Refuser tous les cookies non essentiels
  const handleDeclineAll = () => {
    const allDeclined = {
      necessary: true,
      preferences: false
    };

    setCookieSettings(allDeclined);
    saveConsent(allDeclined);
    setShowModal(false);
    setShowBanner(false);
    setShowFloatingButton(true);

    console.log('❌ Cookies refusés pour 60 jours');
  };

  // Sauvegarder les préférences personnalisées
  const handleSavePreferences = () => {
    saveConsent(cookieSettings);
    setShowModal(false);
    setShowBanner(false);
    setShowFloatingButton(true);

    console.log('⚙️ Préférences sauvegardées pour 60 jours');
  };

  const openPreferences = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const updateSetting = (setting, value) => {
    setCookieSettings(prev => ({
      ...prev,
      [setting]: value
    }));
  };

  return (
    <>
      {/* Bandeau cookies en bas de page - NON BLOQUANT */}
      {showBanner && (
        <div className="cookie-banner">
          <div className="cookie-banner-content">
            <div className="cookie-banner-text">
              <div className="cookie-title">
                <img src={inovact} alt="Cookie" className="cookie-icon" />
              </div>
              
              <p>
                Ce site utilise des cookies pour collecter des données auprès de nos internautes.
                Cette collecte a pour finalité(s) :
              </p>
              <ul className="cookie-finalites">
                <li>au suivi et à l'orientation de la clientèle ;</li>
                <li>à l'identification et à la gestion de l'expérience utilisateur ;</li>
                <li>à la prospection et au ciblage marketing.</li>
              </ul>
              <p>
                Les cookies restent actifs pendant {COOKIE_DURATION_DAYS} jours.
                <br /><br />
                {/* <a href="/politique-protection-donnees" className="cookie-policy-link">
                  Visitez notre politique de protection des données personnelles
                </a> */}
              </p>
            </div>
            <div className="cookie-banner-buttons">
              <button onClick={handleDeclineAll} className="cookie-btn-decline">
                Tout refuser
              </button>
              <button onClick={openPreferences} className="cookie-btn-preferences">
                Plus d'options
              </button>
              <button onClick={handleAcceptAll} className="cookie-btn-accept">
                Tout accepter
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de préférences */}
      {showModal && (
        <div className="cookie-modal-overlay" onClick={closeModal}>
          <div className="cookie-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cookie-modal-header">
              <div className="cookie-title">
                <img src={cookie} alt="Cookie" className="cookies-icon" />
                <h3>Personnaliser vos préférences</h3>
              </div>
              <button className="cookie-modal-close" onClick={closeModal}>×</button>
            </div>

            <div className="cookie-modal-content">
              <p className="cookie-modal-description">
                Ce site utilise des cookies pour collecter des données auprès de nos internautes.
                Cette collecte a pour finalité(s) :
              </p>
              <ul className="cookie-modal-finalites">
                <li>au suivi et à l'orientation de la clientèle ;</li>
                <li>à l'identification et à la gestion de l'expérience utilisateur ;</li>
                <li>à la prospection et au ciblage marketing.</li>
              </ul>
              <p className="cookie-modal-duration">
                Les cookies restent actifs pendant {COOKIE_DURATION_DAYS} jours.
                <br /><br />
                {/* <a href="/politique-protection-donnees" className="cookie-policy-link">
                  Visitez notre politique de protection des données personnelles
                </a> */}
              </p>

              <div className="cookie-categories">
                <div className="cookie-category">
                  <div className="cookie-category-header">
                    <div className="cookie-category-title">
                      <input
                        type="checkbox"
                        checked={cookieSettings.necessary}
                        disabled
                        id="cookie-necessary"
                      />
                      <label htmlFor="cookie-necessary">
                        <strong>Cookies nécessaires</strong>
                      </label>
                    </div>
                    <span className="cookie-badge always-active">Toujours actif</span>
                  </div>
                  <p>Essentiels pour le fonctionnement du site. Ne peuvent pas être désactivés.</p>
                </div>

                <div className="cookie-category">
                  <div className="cookie-category-header">
                    <div className="cookie-category-title">
                      <input
                        type="checkbox"
                        id="cookie-preferences"
                        checked={cookieSettings.preferences}
                        onChange={(e) => updateSetting('preferences', e.target.checked)}
                      />
                      <label htmlFor="cookie-preferences">
                        <strong>Cookies de préférences</strong>
                      </label>
                    </div>
                  </div>
                  <p>Mémorisent vos préférences pour personnaliser votre expérience (thème, langue, etc.).</p>
                </div>
              </div>
            </div>

            <div className="cookie-modal-footer">
              <button onClick={handleDeclineAll} className="cookie-modal-btn-decline">
                Tout refuser
              </button>
              <button onClick={handleSavePreferences} className="cookie-modal-btn-save">
                Enregistrer mes choix
              </button>
              <button onClick={handleAcceptAll} className="cookie-modal-btn-accept">
                Tout accepter
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default CookieManager;